import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BasicMachineFunctionsService } from 'src/app/services/apiHandler/basicMachineFunctions/basic-machine-functions.service';
import { DidConfigService } from 'src/app/services/apiHandler/did-config/did-config.service';
import { t_DataIdentifier } from 'src/app/services/apiHandler/did-data-retrieval/did-data-retrieval.service';
import { GatewayConnectionService } from 'src/app/services/apiHandler/gateway-connection/gateway-connection.service';

@Component({
    selector: 'app-basic-machine-functions-views-list',
    templateUrl: './basic-machine-functions-views-list.component.html',
    styleUrls: ['./basic-machine-functions-views-list.component.scss'],
})
export class BasicMachineFunctionsViewsListComponent implements OnInit {
    
    constructor(public apiConnection: BasicMachineFunctionsService, private gwConnection: GatewayConnectionService, public didConfigConnection: DidConfigService, public router: Router) {}

    ngOnInit(): void {
        // Connect to Gateway on Opening this View
        this.gwConnection.establishConnectionToGateway(8, 1500);
    }

    public async clickBasicFunctionName(funcName: string) {
        // TODO Refactor to work from here with index of basicMachineConfig and not funcname
        let dataIdentifierList: t_DataIdentifier[] = [];

        this.apiConnection.setDataIdentifiersOfFunction(funcName).then(async () => {
            let functionConfig = this.apiConnection.basicMachineFunctionsConfig.functions.find((func) => func.name === funcName);
            functionConfig!.dataNames.forEach((dataName) => {
                if (dataName.identifier != undefined) {
                    dataIdentifierList.push(dataName.identifier);
                }
            });
            await this.putDataIdentifierToQueryList(dataIdentifierList);
        });
        this.router.navigate(['machineState/graph-equipment/', funcName]);
    }

    private putDataIdentifierToQueryList(dataIdentifierList: t_DataIdentifier[]): Promise<void> {
        return new Promise((resolve) => {
            this.didConfigConnection.addDidToQueryList(dataIdentifierList).subscribe({
                next: (response) => {},
                complete() {
                    resolve();
                },
            });
        });
    }
}
